import React from "react";
import { motion } from "framer-motion";
import WhyChooseUs from "../UI/WhyChooseUs";

const WhyChooseUsMEP = () => {
  const features = [
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2Fwhy_choose_us%2FComprehensive_MEP_Planning.png?alt=media&token=d8672513-0a90-46e1-8789-abf37fde22c2",
      title: "Comprehensive MEP Planning",
      description:
        "Integrated planning for all mechanical, electrical, and plumbing systems.",
    },
    {
      icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2Fwhy_choose_us%2FEnergy_Efficient_Designs.png?alt=media&token=fef30b07-df14-48fe-9b78-9c8a0ecfe27b",
      title: "Energy-Efficient Designs",
      description: "Sustainable solutions that optimize resource utilization.",
    },
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2Fwhy_choose_us%2FCompliance_with_Standards.png?alt=media&token=898f8ef5-cab9-458c-8e21-76619fbff859",
      title: "Compliance with Standards",
      description: "Adherence to international and local building codes.",
    },
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2Fwhy_choose_us%2FQuick_Turnaround_Time.png?alt=media&token=53faa47e-1716-429c-8829-618ee7223255",
      title: "Quick Turnaround Time",
      description: "Efficient delivery without compromising quality.",
    },
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2Fwhy_choose_us%2FAdvanced_Drafting_Technology.png?alt=media&token=d9f793f3-0b22-4b7a-82cf-c9a6963bc807",
      title: "Advanced Drafting Technology",
      description: "State-of-the-art tools for precise documentation.",
    },
  ];

  return (
    <><WhyChooseUs features={features}/></>
  );
};

export default WhyChooseUsMEP;
